import React, { useState } from 'react';
import {useFirebase} from 'react-redux-firebase';
import {useHistory} from 'react-router-dom';
import {LogIn,Container,Form,TextInput,Button,FormImage} from '../../styles/Login-Styles';
const Login = () =>{

    let history = useHistory();
    const [email, setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [login,setLogin] = useState('Login');
    const firebase = useFirebase();

    const onSubmit =async (e) =>{
        setLogin('Logging in ...');
        e.preventDefault();
        await firebase.login({
            email,
            password
        });
        history.push('/dashboard');

    }
    return(
        <LogIn>
            <Container>
            <Form onSubmit={onSubmit}>
            <FormImage src={require('../../assets/gradient.svg').default}/>
            <TextInput required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Enter Email"/>
            <TextInput required  type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Enter Password"/>
            <Button>{login}</Button>
            </Form>
            </Container>
        </LogIn>
                
    )
}

export default Login